<template>
  <div>
    <calendarYear :selectingYear="selectingYear"
                  :setSelectYear="setSelectYear"
                  :disableCalendarYearButton="disableCalendarYearButton" />
    <div class="set-position-month">
      <table class="table table-bordered" align="center" id="calendar-month">
        <tbody class="block-month">
          <template v-if="disableCalendarYearButton">
            <div class="infinite-loading-container icon-load"><i class="loading-default"></i></div>
          </template>
          <template v-else>
            <tr>
              <td class="bg-hover-color-skin-light-10 set-hover-border" v-for="index in 12" @click="autoFocus(index)" :class="{ 'active bg-color-skin'  : checkSelectedMonth(index) }">
                <div :class="{ 'selected-month border-color-skin' : checkCurrentMonth(index) }">{{ month[nowLang][index - 1].short }}<i :class="{ 'fa fa-star color-skin' : checkCalendarMain(0, index) }"></i></div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import calendarYear from 'components/calendar/calendar_year'
export default {
  name: 'mode_month',
  props: [ 'currentYear', 'currentMonth', 'selectingYear', 'setSelectYear', 'setSelectMonth', 'month', 'checkCurrentMonth', 'checkSelectedMonth', 'nowLang', 'disableCalendarYearButton', 'checkCalendarMain', 'autoFocusCalendarTab', 'calendarTab1', 'calendarTab2', 'calendarTab3', 'calendarTab4' ],
  methods: {
    autoFocus (index) {
      this.setSelectMonth(index)
      this.autoFocusCalendarTab({ tab: 'tab1', calendarTabRows: this.calendarTab1.rows })
      this.autoFocusCalendarTab({ tab: 'tab2', calendarTabRows: this.calendarTab2.rows })
      this.autoFocusCalendarTab({ tab: 'tab3', calendarTabRows: this.calendarTab3.rows })
      this.autoFocusCalendarTab({ tab: 'tab4', calendarTabRows: this.calendarTab4.rows })
    }
  },
  components: {
    calendarYear
  }
}
</script>
<style>
  .set-position-month{
    padding: 30px 20px 20px 20px;
  }
</style>


// WEBPACK FOOTER //
// mode_month.vue?08bad1a8